export default "__VITE_ASSET__aQsbPred__"